import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ThanhVienKho } from 'src/app/shared/ThanhVienKho.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class ThanhVienKhoService extends BaseService{

    list: ThanhVienKho[] | undefined;
    list001: ThanhVienKho[] | undefined;
    formData!: ThanhVienKho;     

    displayColumns001: string[] = ['STT', 'ID', 'DanhMucNguyenVatLieuID', 'SoLuongNhap', 'SoLuongXuat', 'SoLuongTon'];   

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "ThanhVienKho";
    }
}

